/**
 * Brazilian Portuguese (pt-BR) mappings for MMA Mobile Dashboard
 * Mobile-specific translations for MMA/UFC components
 */

export const mmaMobilePtBR = {
  // Header
  "Sports Hub · MMA": "Centro Esportivo · MMA",
  "MMA Terminal": "Terminal MMA",
  "Track live fights, odds, and fighter analytics across MMA events worldwide.": "Acompanhe lutas ao vivo, cotações e análises de lutadores em eventos de MMA no mundo todo.",
  "MMA": "MMA",
  "UFC events & fights": "Eventos e lutas do UFC",
  
  // Beta Notice
  "Live events & predictions • Rankings coming soon": "Eventos ao vivo e previsões • Rankings em breve",
  
  // Tabs
  "Events": "Eventos",
  "Rankings": "Rankings",
  "Fighters": "Lutadores",
  
  // Status
  "LIVE": "AO VIVO",
  "Final": "Final",
  "TBD": "A definir",
  "In Progress": "Em Andamento",
  "Finished": "Finalizado",
  "Completed": "Concluído",
  
  // Fight Info
  "TITLE": "TÍTULO",
  "Rounds": "Rounds",
  "Round": "Round",
  "Fighter 1": "Lutador 1",
  "Fighter 2": "Lutador 2",
  "Odds": "Cotações",
  
  // Empty States
  "No fights scheduled": "Nenhuma luta agendada",
  "No fights found for": "Nenhuma luta encontrada para",
  "View Today's Events": "Ver Eventos de Hoje",
  "Rankings coming soon": "Rankings em breve",
  "UFC fighter rankings will be available in a future update": "Rankings de lutadores do UFC estarão disponíveis em uma atualização futura",
  "Fighter profiles coming soon": "Perfis de lutadores em breve",
  "Detailed fighter statistics will be available in a future update": "Estatísticas detalhadas de lutadores estarão disponíveis em uma atualização futura",
  "Failed to load fights": "Falha ao carregar lutas",
  "Failed to load data. Please try again.": "Falha ao carregar dados. Por favor, tente novamente.",
  "Try Again": "Tentar Novamente",
  
  // Loading
  "Loading fights...": "Carregando lutas...",
  
  // Filters
  "Filters": "Filtros",
  "Date": "Data",
  "Weight Class": "Categoria de Peso",
  "All Categories": "Todas as Categorias",
  "Apply Filters": "Aplicar Filtros",
  "Filter options coming soon": "Opções de filtro em breve",
  
  // Weight Classes
  "Heavyweight": "Peso Pesado",
  "Light Heavyweight": "Meio-Pesado",
  "Middleweight": "Peso Médio",
  "Welterweight": "Meio-Médio",
  "Lightweight": "Peso Leve",
  "Featherweight": "Peso Pena",
  "Bantamweight": "Peso Galo",
  "Flyweight": "Peso Mosca",
  "Women's Featherweight": "Peso Pena Feminino",
  "Women's Bantamweight": "Peso Galo Feminino",
  "Women's Flyweight": "Peso Mosca Feminino",
  "Women's Strawweight": "Peso Palha Feminino",
  
  // Pagination
  "Previous": "Anterior",
  "Next": "Próximo",
  
  // Fight Details Sheet
  "Fight Details": "Detalhes da Luta",
  "Status": "Status",
  
  // Prediction
  "AI Pick": "Escolha da IA",
  "Analyzing...": "Analisando...",
  
  // Mobile Prediction Bar
  "Fight Selected (Max 5)": "Luta Selecionada (Máx 5)",
  "Fights Selected (Max 5)": "Lutas Selecionadas (Máx 5)",
  "7 coins/fight": "7 moedas/luta",
  "coins total": "moedas total",
  "Predict Winners": "Prever Vencedores",
  "Predicting...": "Prevendo...",
  "Insufficient Star Coins. Need": "Moedas Estrela insuficientes. Precisa de",
  "coins.": "moedas.",
  
  // Time
  "ET": "ET",
  "Today": "Hoje",
  "Tomorrow": "Amanhã",
  "Yesterday": "Ontem",
  
  // Date Picker
  "Select Date": "Selecionar Data",
  "January": "Janeiro",
  "February": "Fevereiro",
  "March": "Março",
  "April": "Abril",
  "May": "Maio",
  "June": "Junho",
  "July": "Julho",
  "August": "Agosto",
  "September": "Setembro",
  "October": "Outubro",
  "November": "Novembro",
  "December": "Dezembro",
  "Su": "Dom",
  "Mo": "Seg",
  "Tu": "Ter",
  "We": "Qua",
  "Th": "Qui",
  "Fr": "Sex",
  "Sa": "Sáb",
  "Next Week": "Próxima Semana",
  
  // Close/Back
  "Close": "Fechar",
  
  // Upgrade Notice
  "Upgrade to Premium": "Atualizar para Premium",
  "Get unlimited predictions": "Obtenha previsões ilimitadas"
};